/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelSiteResponseModel } from '../../models/paged-model-site-response-model';

export interface ListMerchantSites$Params {
  merchantId: string;
}

export function listMerchantSites(http: HttpClient, rootUrl: string, params: ListMerchantSites$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelSiteResponseModel>> {
  const rb = new RequestBuilder(rootUrl, listMerchantSites.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelSiteResponseModel>;
    })
  );
}

listMerchantSites.PATH = '/merchants/{merchantId}/sites';
